// extracted by mini-css-extract-plugin
module.exports = {"login-disclaimer-text":"login-disclaimer_login-disclaimer-text__RNrS_"};